import React from 'react';

interface Props {
    className?: string;
}

export default function ErrorIcon(props: Props) {
    const {className} = props;

    return (
        <svg
            width='28'
            height='28'
            viewBox='0 0 28 28'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <circle cx='14' cy='14' r='14' fill='#FEAD9A' />
            <circle cx='14' cy='14' r='9' fill='white' />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M6 14C6 12.154 6.635 10.457 7.688 9.103L18.897 20.312C17.542 21.365 15.846 22 14 22C9.589 22 6 18.411 6 14ZM20.312 18.897L9.103 7.688C10.458 6.635 12.154 6 14 6C18.411 6 22 9.589 22 14C22 15.846 21.365 17.543 20.312 18.897ZM4 14C4 19.514 8.486 24 14 24C19.514 24 24 19.514 24 14C24 8.486 19.514 4 14 4C8.486 4 4 8.486 4 14Z'
                fill='#BF0711'
            />
        </svg>
    );
}
